export default __webpack_public_path__ + "static/media/460.1dff4513.jpg";